<template>
  <div>
    <div
      class="product"
      :style="{
        mixWidth:
          $vuetify.display.mobile || $vuetify.display.mobile ? '100%' : '',
      }"
    >
      <div class="product-img">
        <img :src="product?.Part?.image" alt="" />
      </div>
      <div class="product-contact">
        <div>
          <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-space-between">
              <div class="detail">
                <div class="product-name">{{ product?.Part?.name }}</div>
              </div>
              <div @click="$emit('removeProduct', product)" class="remove-bg">
                <v-icon
                  :size="20"
                  :color="'#E46E71'"
                  :icon="'mdi-trash-can-outline'"
                />
              </div>
            </div>
            <div class="d-flex space-between">
              <div class="d-flex ga-2">
                <label v-if="product?.Part?.package" class="font-weight-bold">{{
                  $t("Products.productItem.package")
                }}</label>
                <div>{{ product?.Part?.package }}</div>
                <label v-if="false" class="font-weight-bold">{{
                  $t("Products.productItem.height")
                }}</label>
                <div>{{ product?.Part?.height }}</div>
              </div>
              <Prices
                :sku="Number(product?.Part?.sku)"
                :discountPrice="product?.Part?.discountPrice"
                :originPrice="product?.Part?.originPrice"
              />
            </div>
            <div class="divider"></div>
          </div>
        </div>

        <div class="prices-wrapper">
          <div class="quantity-wrapper">
            <QuantityButtons
              :packageQuant="product?.Part?.package"
              :TheCounter="product.quant"
              @updateCounter="updateProduct"
              :disabled="isQuantityBtnDisable"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantityButtons from "../helpers/QuantityButtons.vue";
import Prices from "./Prices.vue";
export default {
  emits: ["updateProduct", "removeProduct", "moreInfo"],
  components: {
    QuantityButtons,
    Prices,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isQuantityBtnDisable: {
      type: Boolean,
    },
  },
  methods: {
    updateProduct(quantity) {
      this.$emit("updateProduct", { quantity, product: this.product });
    },
  },
  computed: {},
};
</script>
<style scoped lang="scss">
.divider {
  width: 100%;
  border-bottom: 1px dashed #dcdcdc;
  margin: 10px 0px;
}
.product {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.product-contact {
  flex-basis: 80%;
}
.product-img {
  flex-basis: 20%;
}
.prices-wrapper {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-start;
}
.quantity-wrapper {
  min-width: 140px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
}
.remove-bg {
  background: #f8d8d9;
  padding: 7px 10px;
  height: fit-content;
  border-radius: 10px;
}
.detail {
  label {
    font-weight: 700;
  }
  .product-name {
    margin-top: 5px;
    font-size: 20px;
    margin-bottom: 15px;
    color: black;
  }
  div {
    line-height: 21px;
    color: $orderLineColor;
  }
}
img {
  object-fit: contain;
  width: 80px;
}
.more-info {
  cursor: pointer;
  margin-top: 10px;
  span {
    text-decoration: underline;
    color: #434343;
  }
}
html:has(.isMobile) {
  .quantity-wrapper {
    justify-content: flex-start;
    .wrapper {
      align-items: flex-start;
    }
  }
  .prices-wrapper {
    // flex-direction: column-reverse !important;
    // align-items: flex-start;
  }
  .product {
    padding: 10px !important;
    gap: 5px;
  }
  img {
    width: 80px !important;
    border-radius: 10px;
  }
  .product-name {
    margin-bottom: 5px;
    font-size: 16px;
  }
}
</style>
